import { createAction, props } from "@ngrx/store";
import { AvailableFeaturesDto } from "src/app/shared/models/features/available-feature-dto.interface";
import { BatchToggleFeatureDto } from "src/app/shared/models/features/batch-toggle-feature-dto.interface";
import { ToggleFeatureDto } from "src/app/shared/models/features/toggle-feature-dto.interface";
import { UserFeatureDto } from "src/app/shared/models/features/user-feature-dto.interface";
import { SuccessDto } from "src/app/shared/models/success-dto";

export const invokeAllFeatures = createAction(
  "[ Invoke Get All Features ] Invoke get all features",
    props<{ email: string }>()
);

export const getAllFeatures = createAction(
  "[ Get All Features ] Get all features",
  props<{ features: UserFeatureDto[] | null }>()
);

export const invokeAllAvailableFeatures = createAction(
  "[ Invoke Get All Available Features ] Invoke get all available features"
);

export const getAllAvailableFeatures = createAction(
  "[ Get All Available Features ] Get all available features",
  props<{ availableFeatures: AvailableFeaturesDto[] | null }>()
);

export const invokeEnableFeature = createAction(
  "[ Enable Feature ] enable feature",
  props<{ payload: ToggleFeatureDto }>()
)

export const invokeDisableFeature = createAction(
  "[ Disable Feature ] disable feature",
  props<{ payload: ToggleFeatureDto }>()
)

export const enableFeatureSuccess = createAction(
  "[Enable Feature Success] enable feature success",
  props<{ success: SuccessDto | null }>()
);

export const disableFeatureSuccess = createAction(
  "[Disable Feature Success] disable feature success",
  props<{ success: SuccessDto | null }>()
);

export const invokeBatchToggleFeature = createAction(
  "[Batch Toggle Features] batch toggle features",
  props<{ payload: BatchToggleFeatureDto }>()
)

export const batchToggleFeatureSuccess = createAction(
  "[Batch Toggle Feature Success] batch toggle feature success",
  props<{ success: SuccessDto | null }>()
);
